import QuarantinedReasonsSelect from './QuarantinedReasonsSelect';

export default QuarantinedReasonsSelect;
